import { render, staticRenderFns } from "./one2coin-withdraw.vue?vue&type=template&id=6a814857&"
import script from "./one2coin-withdraw.vue?vue&type=script&lang=js&"
export * from "./one2coin-withdraw.vue?vue&type=script&lang=js&"
import style0 from "./one2coin-withdraw.vue?vue&type=style&index=0&id=6a814857&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports